import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VagaReportService {
  private apiVagas = `${environment.apiProfissionaisUrl.replace(/\/+$/, '')}/profissionais`;

  constructor(private http: HttpClient) {}

  filtrarVagas(params: any): Observable<any> {
    const httpParams = this.buildHttpParams(params);
    return this.http.get(`${this.apiVagas}/infos`, { params: httpParams });
  }

  sendReportPDF(params: any): Observable<Blob> {
    const headers = new HttpHeaders().set('Accept', 'application/pdf');
    const httpParams = this.buildHttpParams(params);

    return this.http.get(`${this.apiVagas}/Relatorio_Filtro`, {
      headers,
      params: httpParams,
      responseType: 'blob',
    });
  }

  sendReportExcel(params: any): Observable<Blob> {
    const headers = new HttpHeaders().set(
      'Accept',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );
    const httpParams = this.buildHttpParams(params);

    return this.http.get(`${this.apiVagas}/GerarExcelVagas`, {
      headers,
      params: httpParams,
      responseType: 'blob',
    });
  }

  private buildHttpParams(params: any): HttpParams {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return httpParams;
  }
}
